/** Prima por día libre trabajado: pago base + 130% del pago base (= x2.3). */
export const FREE_DAY_WORKED_PREMIUM_RATE = 1.3;

export function withFreeDayWorkedPremium(basePay: number): number {
  return basePay + basePay * FREE_DAY_WORKED_PREMIUM_RATE;
}

/** Si ya hay incidencia aceptada de día libre trabajado, el pago base ya incluye la prima en calculateDailyPayment. */
export function hasAcceptedFreeDayWorkedIncident(
  incidents: any[] | undefined | null
): boolean {
  return (incidents || []).some(
    (i: any) =>
      i?.finalStatus === true &&
      (i?.isFreeDayWorked === true || i?.status === "Día libre gozado")
  );
}
